import { useOfflineSnackbar } from '@/components/GlobalSnackbar/useOfflineSnackbar';

export const GlobalSnackbar = () => {
  useOfflineSnackbar();

  return null;
};
